__turbopack_context__.v({
  "description": "WReferenceLinkingToUrlGreyBack-module__j7cHUq__description",
  "link": "WReferenceLinkingToUrlGreyBack-module__j7cHUq__link",
  "root": "WReferenceLinkingToUrlGreyBack-module__j7cHUq__root",
  "title": "WReferenceLinkingToUrlGreyBack-module__j7cHUq__title",
});
